import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import usePatchParams from '@/components/parameters/usePatchParams';
import CheckboxBase from '@/components/core/form/CheckboxBase';

const MCActiveField = ({ param, name, className, options = {}, disabled = false }) => {
  const { value } = param ?? {};
  const { control } = useFormContext();
  const fieldName = `mc_params.uncertainty_active.${name}`;
  const { patchParam } = usePatchParams(options);

  const events = {
    onChange: async e => {
      const checked = e.target.checked;
      await patchParam(name, 'uncertainty_active', checked, fieldName);
    },
  };

  return (
    <CheckboxBase
      id={name}
      name={fieldName}
      control={control}
      type="checkbox"
      {...events}
      checked={value}
      readOnly={disabled}
      disabled={disabled}
      className={className}
    />
  );
};

MCActiveField.propTypes = {
  param: PropTypes.object,
  label: PropTypes.string,
  paramSchema: PropTypes.object,
  name: PropTypes.string,
  className: PropTypes.string,
  options: PropTypes.object,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

export default MCActiveField;
